import { combineReducers } from "redux";
import { Overview, OverviewState } from "./views/admin/default/reducer";
import {
  CampaignDetailsReducer,
  CampaignDetailsState,
} from "./views/admin/campaign_create/reducer";
import {
  CpaCampaignDetailsReducer,
  CpaCampaignDetailsState,
} from "./views/admin/cpaCampaignCreate/reducer";
import { Authentication, AuthenticationState } from "./listener/signin/reducer";
import { Events, EventsState } from "./views/admin/events/reducer";
import { ROAS, ROASState } from "./views/admin/roas/reducer";
import { Retention, RetentionState } from "views/admin/retention/reducer";

export default (state: any, action: any) => {
  return allReducers(state, action);
};

const allReducers = combineReducers({
  overview: Overview,
  events: Events,
  roas: ROAS,
  retention: Retention,
  campaignDetails: CampaignDetailsReducer,
  authentication: Authentication,
  cpaCampaignDetails: CpaCampaignDetailsReducer,
});

export interface RootReducer {
  overview: OverviewState;
  events: EventsState;
  roas: ROASState;
  retention: RetentionState;
  campaignDetails: CampaignDetailsState;
  cpaCampaignDetails: CpaCampaignDetailsState;
  authentication: AuthenticationState;
}
